/**
 * @generated SignedSource<<9c94fe78a38fb67fa345148960362a87>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "documentId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "formatPdf"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "historyEntries"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isHDS"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isVariablesHighlighted"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "name"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "orientation"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "padding"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "pages"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "renderingEngineVersion"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "variables"
},
v11 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "documentId",
        "variableName": "documentId"
      },
      {
        "kind": "Variable",
        "name": "formatPdf",
        "variableName": "formatPdf"
      },
      {
        "kind": "Variable",
        "name": "historyEntries",
        "variableName": "historyEntries"
      },
      {
        "kind": "Variable",
        "name": "isHDS",
        "variableName": "isHDS"
      },
      {
        "kind": "Variable",
        "name": "isVariablesHighlighted",
        "variableName": "isVariablesHighlighted"
      },
      {
        "kind": "Variable",
        "name": "name",
        "variableName": "name"
      },
      {
        "kind": "Variable",
        "name": "orientation",
        "variableName": "orientation"
      },
      {
        "kind": "Variable",
        "name": "padding",
        "variableName": "padding"
      },
      {
        "kind": "Variable",
        "name": "pages",
        "variableName": "pages"
      },
      {
        "kind": "Variable",
        "name": "renderingEngineVersion",
        "variableName": "renderingEngineVersion"
      },
      {
        "kind": "Variable",
        "name": "variables",
        "variableName": "variables"
      }
    ],
    "concreteType": "BasicMutationResponse",
    "kind": "LinkedField",
    "name": "updateDocument",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "UpdateDocumentMutation",
    "selections": (v11/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v5/*: any*/),
      (v8/*: any*/),
      (v10/*: any*/),
      (v7/*: any*/),
      (v6/*: any*/),
      (v9/*: any*/),
      (v1/*: any*/),
      (v4/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "UpdateDocumentMutation",
    "selections": (v11/*: any*/)
  },
  "params": {
    "cacheID": "d0e830826c3d2159e57dfbf4d81a2ec1",
    "id": null,
    "metadata": {},
    "name": "UpdateDocumentMutation",
    "operationKind": "mutation",
    "text": "mutation UpdateDocumentMutation(\n  $documentId: ID!\n  $name: String!\n  $pages: [DocumentSectionInput!]!\n  $variables: String\n  $padding: PaddingInput\n  $orientation: OrientationEnum!\n  $renderingEngineVersion: String\n  $formatPdf: formatPdfEnum\n  $isVariablesHighlighted: Boolean\n  $isHDS: Boolean\n  $historyEntries: [DocumentHistoryEntryInput!]\n) {\n  updateDocument(documentId: $documentId, name: $name, pages: $pages, variables: $variables, padding: $padding, orientation: $orientation, renderingEngineVersion: $renderingEngineVersion, formatPdf: $formatPdf, isVariablesHighlighted: $isVariablesHighlighted, isHDS: $isHDS, historyEntries: $historyEntries) {\n    ok\n    error\n  }\n}\n"
  }
};
})();

node.hash = "deec276f8436dc78cfc8c869dd9dbd25";

export default node;
